import { Injectable } from '@angular/core';
import { ICustomerSource } from '@core/interfaces/customer/customer-source.interface';
import { Customer } from '@core/models/customer/customer.model';
import { Observable } from 'rxjs';
import { take, map, tap } from 'rxjs/operators';
import { ICustomer } from '@core/interfaces/customer/customer.interface';
import { CartStoreService } from '../cart/cart-store.service';

@Injectable()
export class CustomerService {

  constructor(
    private customerSourceService: ICustomerSource,
    private cartStoreService: CartStoreService
  ) { }

  createCustomer(customer: Customer): Observable<Customer> {
    return this.customerSourceService.createCustomer(customer)
      .pipe(
        take(1),
        map((iCustomer: ICustomer) => new Customer(iCustomer)),
        tap((createdCustomer: Customer) => this.cartStoreService.setCustomer(createdCustomer))
      );
  }

  updateCustomer(customer: Customer): Observable<Customer> {
    const customerId = this.cartStoreService.cart.customer.id;

    return this.customerSourceService.updateCustomer({ ...customer, id: customerId })
      .pipe(
        take(1),
        map((iCustomer: ICustomer) => new Customer(iCustomer)),
        tap((updatedCustomer: Customer) => this.cartStoreService.setCustomer(updatedCustomer))
      );
  }

  saveCustomer(customer: Customer): Observable<Customer> {
    return customer.id ? this.updateCustomer(customer) : this.createCustomer(customer);
  }

}
